/* Drawer Accessibility */

(function ($) {

  let $lastFocusedElement = null;
  const $drawer = $('#cart-drawer');
  const $overlay = $('.drawer__overlay');

  const FOCUSABLE_ELEMENTS = `
    a[href],
    button:not([disabled]),
    textarea,
    input,
    select,
    [tabindex]:not([tabindex="-1"])
  `;

  function getFocusable($container) {
    return $container.find(FOCUSABLE_ELEMENTS).filter(':visible');
  }

  function openDrawer(trigger) {
    $lastFocusedElement = trigger;

    $drawer.addClass('is-open')
      .attr('aria-hidden', 'false');

    $('.cart__toggle').attr('aria-expanded', 'true');
    $('body').addClass('drawer-open');

    setTimeout(function () {
      const $focusables = getFocusable($drawer);
      if ($focusables.length) {
        $focusables.first().focus();
      }
    }, 100);
  }

  function closeDrawer() {
    $drawer.removeClass('is-open')
      .attr('aria-hidden', 'true');

    $('.cart__toggle').attr('aria-expanded', 'false');

    $('body').removeClass('drawer-open');

   
    if ($lastFocusedElement && $lastFocusedElement.length) {
      setTimeout(() => $lastFocusedElement.focus(), 100);
    }
  }

  
  $(document).on('click', '[data-cart-drawer-toggle]', function (e) {
    e.preventDefault();
    if ($(this).hasClass('cart-drawer__close')) return;
    openDrawer($(this));
  });

  
  $(document).on('click', '.cart-drawer__close', function (e) {
    e.preventDefault();
    closeDrawer();
  });

  
  $(document).on('click', '.drawer__overlay', function () {
    closeDrawer();
  });

  
  $(document).on('keydown', function (e) {
    if (e.key === "Escape" || e.keyCode === 27) {
      if ($drawer.hasClass('is-open')) {
        closeDrawer();
      }
    }
  });

 
  $(document).on('keydown', function (e) {
    if (!$drawer.hasClass('is-open')) return;

    if (e.key !== 'Tab') return;

    const $focusables = getFocusable($drawer);
    if (!$focusables.length) return;

    const first = $focusables.first()[0];
    const last = $focusables.last()[0];
    const active = document.activeElement;

   
    if (e.shiftKey) {
      if (active === first) {
        e.preventDefault();
        last.focus();
      }
    }
   
    else {
      if (active === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

})(jQuery);



(function ($) {
  'use strict';

  const DRAWER_SEL   = '.pswp';                    
  const CLOSE_SEL    = '.popup-quick-view__close, .pswp__button--close, .pswp__custom-close';
  const TRIGGER_SEL  = '[data-button-quick-view]';    
  const CARD_SEL     = '.product-grid-item';         

 
  const FOCUSABLE    = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(', ');

  let $lastTrigger  = null;   // button that opened the current drawer
  let trapActive    = false;


  function getFocusable($container) {
    return $container.find(FOCUSABLE).filter(function () {
      return (
        $(this).is(':visible') &&
        !$(this).closest('[aria-hidden="true"]').length &&
        $(this).attr('tabindex') !== '-1'
      );
    });
  }

 
  function lockBackground($drawer) {
    $('body').children().not($drawer).each(function () {
      const $el = $(this);
      
      if (!$el.data('a11y-prev-hidden')) {
        $el.data('a11y-prev-hidden', $el.attr('aria-hidden') || 'none');
      }
      $el.attr('aria-hidden', 'true');

      
      this.inert = true;
    });
  }

  
  function unlockBackground() {
    $('body').children().each(function () {
      const $el   = $(this);
      const prev  = $el.data('a11y-prev-hidden');

      if (prev === undefined) return;   

      if (prev === 'none') {
        $el.removeAttr('aria-hidden');
      } else {
        $el.attr('aria-hidden', prev);
      }

     
      this.inert = false;

      $el.removeData('a11y-prev-hidden');
    });
  }


  function enableFocusTrap($drawer) {
    if (trapActive) return;
    trapActive = true;

    $(document).on('keydown.quickBuyTrap', function (e) {
      if (!trapActive) return;

      const $focusable  = getFocusable($drawer);
      if (!$focusable.length) return;

      const $first = $focusable.first();
      const $last  = $focusable.last();

      if (e.key === 'Tab') {
        if (e.shiftKey) {
        
          if (document.activeElement === $first[0]) {
            e.preventDefault();
            $last.trigger('focus');
          }
        } else {
          
          if (document.activeElement === $last[0]) {
            e.preventDefault();
            $first.trigger('focus');
          }
        }
      }

      if (e.key === 'Escape') {
        closeDrawer($drawer);
      }
    });
  }

  function disableFocusTrap() {
    trapActive = false;
    $(document).off('keydown.quickBuyTrap');
  }


  function openDrawer($drawer) {
    lockBackground($drawer);
    enableFocusTrap($drawer);
    if (!$drawer.attr('role'))          $drawer.attr('role', 'dialog');
    if (!$drawer.attr('aria-modal'))    $drawer.attr('aria-modal', 'true');

    
    const titleId = 'qb-dialog-title';
    const $title  = $drawer.find('.popup-quick-view__title');
    if ($title.length && !$drawer.attr('aria-labelledby')) {
      $title.attr('id', titleId);
      $drawer.attr('aria-labelledby', titleId);
    }

   
    setTimeout(function () {
      const $focusable = getFocusable($drawer);
      if ($focusable.length) {
        $focusable.first()[0].focus();
      } else {
        $drawer.attr('tabindex', '-1')[0].focus();
      }
      
      $drawer.attr('aria-live', 'assertive');
    }, 80);
  }

  function closeDrawer($drawer) {
    disableFocusTrap();
    unlockBackground();

    if ($lastTrigger && $lastTrigger.length) {

      document.activeElement.blur();

      setTimeout(function () {
        $lastTrigger[0].focus();

        $lastTrigger.attr('aria-live', 'off');

        $lastTrigger = null;
      }, 120);
    }
  }

  
  function watchDrawer() {
    const drawerEl = document.querySelector(DRAWER_SEL);
    if (!drawerEl) return;

    const $drawer  = $(drawerEl);
    let wasVisible = $drawer.is(':visible') && !$drawer.is('[aria-hidden="true"]');

    const observer = new MutationObserver(function () {
      const isVisible = $drawer.hasClass('pswp--visible') ||
                        ($drawer.is(':visible') && !$drawer.is('[aria-hidden="true"]'));

      if (isVisible && !wasVisible) {
        wasVisible = true;
        openDrawer($drawer);
      } else if (!isVisible && wasVisible) {
        wasVisible = false;
        closeDrawer($drawer);
      }
    });

    observer.observe(drawerEl, {
      attributes    : true,
      attributeFilter: ['class', 'aria-hidden', 'style'],
    });

    $drawer.on('click.quickBuyA11y', CLOSE_SEL, function () {
      closeDrawer($drawer);
    });
  }

  $(document).on('click.quickBuyA11y', TRIGGER_SEL, function () {
    $lastTrigger = $(this);
  });

  $(document).on('keydown.quickBuyA11y', TRIGGER_SEL, function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      $lastTrigger = $(this);
    }
  });


  function reduceCardTabStops() {
    $(CARD_SEL).each(function () {
      const $card    = $(this);
      const $trigger = $card.find(TRIGGER_SEL);

      $card.find(FOCUSABLE).not($trigger).each(function () {
        const $el = $(this);
        if (!$el.data('a11y-orig-tabindex')) {
          $el.data('a11y-orig-tabindex', $el.attr('tabindex') || 'none');
        }
        $el.attr('tabindex', '-1');
      });
      if ($trigger.length) {
        $trigger.attr('tabindex', '0');
      }
    });
  }
  $(function () {
    watchDrawer();
    reduceCardTabStops();
    $(document).on('shopify:section:load theme:ajaxCart:loaded', function () {
      reduceCardTabStops();
    });
  });
  $(document).on('quickview:loaded theme:quickview:loaded', function () {
    const $drawer = $(DRAWER_SEL);
    if ($drawer.length) openDrawer($drawer);
  });

}(jQuery));


(function ($) {

  const $toggleBtn = $('[data-sort-toggle]');
  const $wrapper = $('#collection-sort-options');
  function syncState() {
    const isVisible = $wrapper.hasClass('collection__sort__option-wrapper--visible');
    $toggleBtn.attr('aria-expanded', isVisible ? 'true' : 'false');
  }
  function openDropdown() {
    $wrapper.addClass('collection__sort__option-wrapper--visible');
    $toggleBtn.attr('aria-expanded', 'true');

    setTimeout(() => {
      $wrapper.find('label').first().focus();
    }, 50);
  }
  function closeDropdown() {
    $wrapper.removeClass('collection__sort__option-wrapper--visible');
    $toggleBtn.attr('aria-expanded', 'false');

    setTimeout(() => {
      $toggleBtn.focus();
    }, 50);
  }
  $toggleBtn.off('click').on('click', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const isOpen = $wrapper.hasClass('collection__sort__option-wrapper--visible');

    if (isOpen) {
      closeDropdown();
    } else {
      openDropdown();
    }
  });
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDropdown();
    }
  });
  $(document).on('click', function (e) {
    if (!$(e.target).closest('.collection__sort-bar').length) {
      closeDropdown();
    }
  });
  $wrapper.find('input').on('change', function () {
    closeDropdown();
  });
  $(document).ready(function () {
    syncState();
  });

})(jQuery);


/* Third party warnings */
(function ($) {

  function isThirdParty(href) {
    try {
      const linkHost = new URL(href).hostname;
      const currentHost = window.location.hostname;
      return linkHost !== currentHost;
    } catch (e) {
      return false; // relative URLs = internal
    }
  }

  function processExternalLinks() {
    $('a[href]').each(function () {
      const $link = $(this);
      const href = $link.attr('href');
      if (!isThirdParty(href)) return;
      if ($link.attr('target') !== '_blank') {
        $link.attr('target', '_blank');
      }
      if (!$link.attr('rel')) {
        $link.attr('rel', 'noopener noreferrer');
      }
      if (!$link.attr('aria-label')) {
        const linkText = $link.text().trim() || 'Link';
        $link.attr('aria-label', `${linkText}, opens in a new window`);
      }
    });
  }
  $(document).ready(function () {
    processExternalLinks();
  });
})(jQuery);



/* Add to cart drawer */
(function ($) {

  let lastFocusedElement = null;
  const $drawer = $('#cart-drawer');
  $(document).on('mousedown keydown', '[data-add-to-cart], [data-cart-drawer-toggle], .quantity__btn, .quantity__input', function (e) {
    if (e.type === 'mousedown' || e.key === 'Enter' || e.key === ' ') {
      lastFocusedElement = this;
    }
  });
  function waitForCloseAndReturnFocus() {

    const check = setInterval(function () {
      if (!$drawer.hasClass('is-open')) {

        clearInterval(check);

        if (lastFocusedElement) {
          setTimeout(function () {
            $(lastFocusedElement).focus();
          }, 100); 
        }
      }
    }, 50); 
  }
  $(document).on('click', '.cart-drawer__close', function () {
    waitForCloseAndReturnFocus();
  });

  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' && $drawer.hasClass('is-open')) {
      waitForCloseAndReturnFocus();
    }
  });

 
  $(document).on('click', function (e) {
    if ($drawer.hasClass('is-open')) {

      if (
        !$(e.target).closest('#cart-drawer').length &&
        !$(e.target).closest('[data-cart-drawer-toggle]').length
      ) {
        waitForCloseAndReturnFocus();
      }
    }
  });

})(jQuery);



function addIframeTitle() {
    var iframe = $('#PBarNextFrame');
    
    if (iframe.length) {
        iframe.attr('title', 'Preview Bar Frame');
    } else {
        setTimeout(addIframeTitle, 500); 
    }
}
$(document).ready(function() {
    setTimeout(addIframeTitle, 2000);
});